import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import * as styles from './SuccessModalWindow.css';
import { ResultModalWindow, useResponsiveText } from '../../ResultModalWindow';

export interface ISuccessModalWindowProps {
  onClose: () => void;
  open: boolean;
}

export const SuccessModalWindow: React.FC<ISuccessModalWindowProps> = ({ onClose, open }) => {
  const UIText = useResponsiveText();

  return (
    <ResultModalWindow
      open={open}
      textContent={
        <>
          <div className={styles['title']}>
            <UIHeading2 textAlign="center">Начали искать, скоро перезвоним</UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText>
              Консультант перезвонит в течение пары часов, задаст уточняющие вопросы и предложит
              подходящие&nbsp;варианты
            </UIText>
          </div>
        </>
      }
      data-testid="SuccessModalWindowContent"
      onClose={onClose}
    />
  );
};
